import { DatePipe } from '@angular/common';
import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { UnespCoreAuthService, UnespCoreMessageService } from 'src/libs/unesp-core';
import { ComissaoJulgadoraService } from '../comissao-julgadora-service';
import { TipoConcurso, TipoConcursoDTA, TipoConcursoLabel } from 'src/app/enums/tipo-concurso';
import { TipoProva } from 'src/app/enums/tipo-prova';
import { Concurso } from 'src/app/models/concurso';
import { ActivatedRoute, Router } from '@angular/router';
import { ProvaExaminador } from 'src/app/models/prova-examinador.model';
import { VisualizarClassificacaoFase1Component } from '../visualizar-classificacao-fase1/visualizar-classificacao-fase1.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalPendenciasClassificacaoComponent } from '../modal-pendencias-classificacao/modal-pendencias-classificacao.component';
import { ModalPendenciasProvaAndamentoComponent } from '../modal-pendencias-prova-andamento/modal-pendencias-prova-andamento.component';
import { ReporteIdentificacaoService } from 'src/app/services/reporte-identificacao.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'inscricoes-lista-prova-examinador-unicamp',
  templateUrl: './lista-prova-examinador.component.html',
  styleUrls: ['./lista-prova-examinador.component.scss'],
})
export class ListaProvaExaminadorComponent implements OnInit {
  private destroyRef = inject(DestroyRef)


  idConcurso: number = 0;
  concursoFase?: string;
  classificacaoFase2Consolidada: boolean = false;
  
  provasFase1: ProvaExaminador[] = [];
  provasFase2: ProvaExaminador[] = [];

  documentosHabilitado: boolean = false;

  allFase1Concluida: boolean = false;
  allFase2Concluida: boolean = false;
  allEnvelopesFinalizados: boolean = false;
  existeEmpate: boolean = false;
  possuiMalote: boolean = false;
  datepipe: DatePipe = new DatePipe('pt-BR');
  instrucoesExpandidas: boolean = false;
  pendenciasClassificacao: any = null;
  verificandoPendencias: boolean = false;

  tipoConcurso = TipoConcurso;
  tipoConcursoDTA = TipoConcursoDTA;
  reportesPendentes: number = 0;

  constructor(
    private unespCoreMessageService: UnespCoreMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private comissaoJulgadorService: ComissaoJulgadoraService,
    private unespCoreAuthService: UnespCoreAuthService,
    private dialog: MatDialog,
    private reporteIdentificacaoService: ReporteIdentificacaoService
  ) {}

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.idConcurso = Number(params['idConcurso']);
      this.getData();
    });
  }

  public getData(): void {
    this.comissaoJulgadorService.listarProvasExaminador(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: ProvaExaminador[]) => {

        this.provasFase1 = data.filter(p => p.provaFase === 'FASE1').sort((a, b) => a.provaOrdem - b.provaOrdem);
        this.provasFase2 = data.filter(p => p.provaFase === 'FASE2').sort((a, b) => a.provaOrdem - b.provaOrdem);

        this.allFase1Concluida = this.provasFase1.length > 0 && this.provasFase1.every(p => p.concluido);
        this.allFase2Concluida = this.provasFase2.length > 0 && this.provasFase2.every(p => p.concluido);

        if (data.length > 0) {
          this.allEnvelopesFinalizados = data[0].envelopesFinalizados;
          this.existeEmpate = data[0].existeEmpate;
          this.possuiMalote = data[0].possuiMalote;
          this.concursoFase = data[0].concursoFase;
          this.classificacaoFase2Consolidada = data[0].classificacaoFase2Consolidada ?? false;
        } else {
          this.allEnvelopesFinalizados = false;
          this.existeEmpate = false;
          this.possuiMalote = false;
          this.classificacaoFase2Consolidada = false;
        }

        this.calcularDocumentosHabilitado();
        this.verificarPendenciasAutomaticamente();

        if (this.isPresidente()) {
          this.reporteIdentificacaoService.listarPendentes(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
            data => this.reportesPendentes = data.length
          )
        }
      },
      error: (err) => {
        console.error('Erro ao carregar provas:', err);
        if (err?.error?.message?.toLowerCase().includes('aguarde')){
          this.unespCoreMessageService.showMessageWarning(err.error.message, 'Fechar', 0)
        } else {
          this.unespCoreMessageService.showMessageError(
            err?.error?.message ?? 'Erro ao carregar dados das provas.'
          );
        }
      }
    });
  }

  public isProvaProntaParaLancamento(prova: ProvaExaminador): boolean {
    return !prova.concluido &&
           prova.emAndamento &&
           !prova.notasJaDigitadasPorOutroExaminador &&
           !prova.aguardandoConsolidacao;
  }

  public getBloqueioReason(prova: ProvaExaminador): string {
    if (prova.notasJaDigitadasPorOutroExaminador) return 'Nota já depositada';
    if (prova.aguardandoConsolidacao) return 'Aguardando Fase 1';
    if (!prova.emAndamento) return 'Prova não iniciada';
    return 'Pendente';
  }

  public getBloqueioTooltip(prova: ProvaExaminador): string {
    if (prova.notasJaDigitadasPorOutroExaminador) return 'Nota já depositada pelo examinador substituído';
    if (prova.aguardandoConsolidacao) return 'Aguardando Consolidação das notas da primeira fase';
    if (prova.concluido) return 'Prova já concluída';
    if (!prova.emAndamento) return 'Prova não está em andamento';
    return prova.resumoNotas || 'Status da prova pendente';
  }

  public onClassificar(): void {
    this.comissaoJulgadorService.calcularMediaExaminadores(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.unespCoreMessageService.showMessageSuccess('Cálculo de médias realizado com sucesso.');
        this.router.navigate(['/comissao-julgadora/classificacao', this.idConcurso]);
      },
      error: (err) => {
        console.error('Erro ao calcular médias:', err);
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao calcular médias.'
        );
      }
    });
  }

  public getTipo(tipo: string): string {
    return TipoConcursoLabel.get(tipo) ?? '';
  }

  public canOpenOptions(): boolean {
    return this.unespCoreAuthService.hasPermissionBasedRoles(['EXAMINADOR']);
  }

  public mostrarProvasBtn(concurso: Concurso): boolean {
    return ['EXAMINADOR'].includes(concurso.tipo);
  }

  public isPresidente(): boolean {
    return this.provasFase1.some(p => p.papelExaminador === 'PRESIDENTE') || 
           this.provasFase2.some(p => p.papelExaminador === 'PRESIDENTE');
  }

  public todasNotasAtribuidas(prova: ProvaExaminador): boolean {
    if (!prova.resumoNotas) return false;
    const match = prova.resumoNotas.match(/Notas atribuidas: (\d+) de (\d+)/);
    return match ? match[1] === match[2] : false;
  }

  public getNomeProva(tipoProva: string): string {
    return (TipoProva as any)[tipoProva]?.tipo || tipoProva;
  }

  public visualizarClassificacaoFase1(): void {
    this.comissaoJulgadorService.getClassificacaoFase1(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (classificacao) => {
        this.comissaoJulgadorService.buscarResumoNotasExaminador(this.idConcurso, 'FASE1').pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          next: (resumoNotas) => {
            this.dialog.open(VisualizarClassificacaoFase1Component, {
              width: '90%',
              maxWidth: '1200px',
              data: { classificacao, resumoNotas }
            });
          },
          error: (err) => {
            this.unespCoreMessageService.showMessageError(
              err?.error?.message ?? 'Erro ao carregar resumo das notas.'
            );
          }
        });
      },
      error: (err) => {
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao carregar classificação da Fase 1.'
        );
      }
    });
  }

  public visualizarClassificacaoFase2(): void {
    this.router.navigate(['/comissao-julgadora/resultado/classificacao', this.idConcurso], {
      queryParams: { fase: 'FASE2', examinador: true }
    });
  }

  public realizarDesempateFase(fase: string): void {
    this.router.navigate(['/comissao-julgadora/classificacao', this.idConcurso], {
      queryParams: { fase: fase }
    });
  }

  public getTooltipVisualizarClassificacao(fase: string): string {
    const provasFase = fase === 'FASE1' ? this.provasFase1 : this.provasFase2;
    
    if (provasFase.length === 0) {
      return 'Nenhuma prova cadastrada para esta fase';
    }

    const todasConcluidas = provasFase.every(p => p.concluido);
    if (todasConcluidas) {
      return '';
    }

    const ultimaProva = provasFase.reduce((prev, current) => 
      (current.provaOrdem > prev.provaOrdem) ? current : prev
    );

    const ultimaProvaTemEnvelope = ultimaProva.comissaoNotaEnvelopeId != null;
    if (ultimaProvaTemEnvelope) {
      return '';
    }

    return 'Deposite o envelope da última prova da fase para habilitar';
  }

  public getTooltipVisualizarFase1(): string {
    return 'A Fase deve ser consolidada pelo presidente para habilitar';
  }

  public getTooltipVisualizarFase2(): string {
    return 'A Fase deve ser consolidada pelo presidente para habilitar';
  }

  public existeProvaAguardandoConsolidacao(): boolean {
    return [...this.provasFase1, ...this.provasFase2].some(p => p.aguardandoConsolidacao);
  }

  public existeEmpateFase(fase: string): boolean {
    const provasFase = fase === 'FASE1' ? this.provasFase1 : this.provasFase2;
    return provasFase.length > 0 && provasFase[0].existeEmpate && this.concursoFase === fase;
  }

  public toggleInstrucoes(): void {
    this.instrucoesExpandidas = !this.instrucoesExpandidas;
  }

  private verificarPendenciasAutomaticamente(): void {
    if (!this.isPresidente()) return;

    const provasFaseAtual = this.concursoFase === 'FASE1' ? this.provasFase1 : this.provasFase2;
    if (provasFaseAtual.length === 0) return;

    const todasProvasConcluidas = provasFaseAtual.every(p => p.concluido);
    const ultimaProva = provasFaseAtual.reduce((prev, current) => 
      (current.provaOrdem > prev.provaOrdem) ? current : prev
    );

    if (ultimaProva.comissaoNotaEnvelopeId || todasProvasConcluidas) {
      this.carregarPendencias();
    }
  }

  private carregarPendencias(): void {
    this.verificandoPendencias = true;
    this.comissaoJulgadorService.verificarPendenciasClassificacao(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (pendencias) => {
        this.verificandoPendencias = false;
        this.pendenciasClassificacao = pendencias;
      },
      error: (err) => {
        this.verificandoPendencias = false;
        console.error('Erro ao verificar pendências:', err);
      }
    });
  }

  public verificarPendencias(): void {
    this.verificandoPendencias = true;
    this.comissaoJulgadorService.verificarPendenciasClassificacao(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (pendencias) => {
        this.verificandoPendencias = false;
        this.pendenciasClassificacao = pendencias;
        
        // Verifica se ainda há pendências
        const temSemMalote = pendencias.examinadoresSemMalote?.length > 0;
        const temEmpatadas = pendencias.examinadoresComNotasEmpatadas?.length > 0;
        const temPendencias = temSemMalote || temEmpatadas;
        
        if (temPendencias) {
          this.abrirModalPendencias();
        } else {
          // Se não há mais pendências, redireciona para consolidação
          this.router.navigate(['/comissao-julgadora/resultado/classificacao', this.idConcurso]);
        }
      },
      error: (err) => {
        this.verificandoPendencias = false;
        console.error('Erro ao verificar pendências:', err);
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao verificar pendências de classificação.'
        );
      }
    });
  }

  public temPendencias(): boolean {
    if (!this.pendenciasClassificacao) {
      return false;
    }
    const temSemMalote = this.pendenciasClassificacao.examinadoresSemMalote?.length > 0;
    const temEmpatadas = this.pendenciasClassificacao.examinadoresComNotasEmpatadas?.length > 0;
    return temSemMalote || temEmpatadas;
  }

  public podeConsolidarFase(): boolean {
    const provasFaseAtual = this.concursoFase === 'FASE1' ? this.provasFase1 : this.provasFase2;
    const todasProvasConcluidas = provasFaseAtual.length > 0 && provasFaseAtual.every(p => p.concluido);
    return todasProvasConcluidas;
  }

  public abrirModalPendencias(): void {
    this.dialog.open(ModalPendenciasClassificacaoComponent, {
      width: '600px',
      data: this.pendenciasClassificacao
    });
  }

  public consultarPendenciasProva(prova: ProvaExaminador): void {
    this.comissaoJulgadorService.verificarPendenciasProvaEmAndamento(this.idConcurso).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (pendencias) => {
        pendencias.reportesPendentes = prova.tipoProva === 'ESCRITA' ? this.reportesPendentes : 0;
        pendencias.concursoId = this.idConcurso;
        this.dialog.open(ModalPendenciasProvaAndamentoComponent, {
          width: '90vw',
          maxWidth: '1400px',
          data: pendencias
        });
      },
      error: (err) => {
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao consultar pendências da prova.'
        );
      }
    });
  }

  private calcularDocumentosHabilitado(): void {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const provasFaseAtual = this.concursoFase === 'FASE2' ? this.provasFase2 : this.provasFase1;
    const primeiraProva = provasFaseAtual.find(p => p.provaOrdem === 1);

    if (primeiraProva?.dataInicioDocumentos) {
      const [year, month, day] = primeiraProva.dataInicioDocumentos.split('-').map(Number);
      const dataInicio = new Date(year, month - 1, day);
      this.documentosHabilitado = dataInicio <= hoje;
    } else {
      this.documentosHabilitado = false;
    }
  }

  public visualizarDocumentosConcurso(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/comissao-julgadora/documentos-concurso', this.idConcurso])
    );
    window.open(url, '_blank');
  }
}
